import axios from "../config";
import { API_VERSION } from "config";

export const getAwsKeys = (params) =>
  axios.post(`${API_VERSION}/datasets/getConfig`, { params });

  export const getDirectoryAwsKeys = (params) =>
  axios.get(`${API_VERSION}/directory/getConfig`, { params });
